// SkeletonRow.tsx
import React from "react";

type SkeletonRowProps = {
  columns: number;
};

const SkeletonRow: React.FC<SkeletonRowProps> = ({ columns }) => {
  return (
    <tr>
      {Array.from({ length: columns }).map((_, colIndex) => (
        <td
          key={`col-${colIndex}`}
          className="px-6 py-3 whitespace-nowrap text-sm text-gray-900"
        >
          <div className="w-full h-6 bg-gray-200 rounded animate-pulse"></div>
        </td>
      ))}
    </tr>
  );
};

export default SkeletonRow;
